// Structured-data (JSON-LD schema.org) builders. These help Google and AI search
// engines understand and richly cite Dharmartha's pages.

const SITE = "Dharmartha";
const ORIGIN = (typeof window !== "undefined" && window.location?.origin) || "https://dharmartha.org";

const strip = (s) => String(s || "").replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();

export function organizationLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE,
    alternateName: "धर्मार्थ",
    url: ORIGIN,
    logo: `${ORIGIN}/favicon.png`,
    description:
      "Dharmartha (धर्मार्थ) is a calm, editorial digital gateway to the knowledge traditions of Bharat — kathas, mantras, suktas, puja vidhi, stotras, deities, temples, festivals and a live daily Panchang.",
  };
}

export function breadcrumbLd(items = []) {
  // items: [{ name, path }]
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${ORIGIN}${it.path || ""}`,
    })),
  };
}

export function articleLd({ title, description, image, path, datePublished, dateModified }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: strip(title),
    description: strip(description),
    image: image ? [image] : undefined,
    mainEntityOfPage: `${ORIGIN}${path || ""}`,
    author: { "@type": "Organization", name: SITE },
    publisher: {
      "@type": "Organization",
      name: SITE,
      logo: { "@type": "ImageObject", url: `${ORIGIN}/favicon.png` },
    },
    datePublished: datePublished || undefined,
    dateModified: dateModified || datePublished || undefined,
    inLanguage: ["en", "hi"],
  };
}

export function bookLd({ title, description, image, path, author, year, language }) {
  return {
    "@context": "https://schema.org",
    "@type": "Book",
    name: strip(title),
    description: strip(description),
    image: image || undefined,
    url: `${ORIGIN}${path || ""}`,
    bookFormat: "https://schema.org/EBook",
    author: author ? { "@type": "Person", name: author } : { "@type": "Organization", name: SITE },
    publisher: { "@type": "Organization", name: SITE },
    inLanguage: language || undefined,
    datePublished: year ? String(year) : undefined,
  };
}

export function placeLd({ name, description, image, path, location, state, deity }) {
  return {
    "@context": "https://schema.org",
    "@type": ["Place", "PlaceOfWorship", "TouristAttraction"],
    name: strip(name),
    description: strip(description),
    image: image || undefined,
    url: `${ORIGIN}${path || ""}`,
    address: {
      "@type": "PostalAddress",
      addressLocality: location || undefined,
      addressRegion: state || undefined,
      addressCountry: "IN",
    },
    keywords: [deity, "temple", "Hindu", "Bharat"].filter(Boolean).join(", "),
  };
}

// Combine several schema objects into a single @graph for one <script> tag.
export function graph(...nodes) {
  const clean = nodes.filter(Boolean);
  if (clean.length === 1) return clean[0];
  return { "@context": "https://schema.org", "@graph": clean.map(({ ["@context"]: _c, ...rest }) => rest) };
}
